// extracted by mini-css-extract-plugin
module.exports = {"actionBtn":"actionBtn___15-mO","btnWrap":"btnWrap___1M_UP","bottomTitle":"bottomTitle___3o_fK","actionBtnPad":"actionBtnPad___O5Ava"};